import React from 'react'
import { Brevier } from '~/components/Typography'
import { mediaqueries } from '~/utils/mediaqueries'
import { Trustbox } from '~/components/Trustbox'
import { FacebookProvider, Like } from 'react-facebook'
import Check from '~/icons/check.svg'
import styled from 'styled-components'

import Amex from '~/icons/amex.svg'
import Apay from '~/icons/apay.svg'
import Mc from '~/icons/mc.svg'
import Visa from '~/icons/visa.svg'

const UspWrap = styled.div`
  display: flex;
  overflow: hidden;
  padding: 0 10px;
  background: #fafafa;

  @media ${mediaqueries.md} {
    padding: 0 100px;
  }
`

const Usp = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  min-width: 900px;
  padding: 16px 0;
  text-align: center;
  position: relative;
  animation: marquee 20s linear infinite;

  @media ${mediaqueries.md} {
    padding: 16px 0;
    animation: none;

    &:nth-of-type(2) {
      display: none;
    }
  }
`

const UspItem = styled(Brevier)`
  flex: 1;
  margin: 0;
  overflow: hidden;
  display: flex;
  align-items: center;

  justify-content: center;

  &:last-of-type {
    margin: 0;
    justify-content: flex-start;

    & > svg {
      display: none;
    }
  }

  svg {
    flex: 0 0 16px;
    margin-right: 8px;
    fill: #004445;
  } 
  &:last-of-type {
    min-width: 320px !important;
    width: 100%;
  }

  @media ${mediaqueries.md} {
    &:last-of-type {
      justify-content: flex-start;

      /*     div {
        width: auto;
        overflow: visible;
      } */
    }
  }
`

const Footer = styled.footer`
  flex: 0 0 100%;
`

const FooterNav = styled.ul`
  border-top: 1px solid #e1e4ed;
  padding: 30px 20px;
  text-align: center;
`

const FooterNavItem = styled.li`
  color: #626468;
  font-size: 15px;
  line-height: 2em;

  a {
    color: inherit;
    text-decoration: none;
  }
`

const FooterPaymentIcons = styled.div`
  display: flex;
  justify-content: center;
  border-top: 1px solid #e1e4ed;
  align-items: center;
  padding: 30px 0;

  svg {
    margin: 0 10px;
  }
`

export default () => (
  <>
    <UspWrap>
      {['', ''].map((item, listIndex) => (
        <Usp key={listIndex}>
          {[
            'Den perfekte gave',
            'Gratis fragt til hele verden',
            'Fantastisk kvalitet',

            <FacebookProvider appId="369662444228229">
              <Like
                href="https://www.facebook.com/typeandmoredesign"
                colorScheme="light"
                showFaces
              />
            </FacebookProvider>,
          ].map((item, index) => (
            <UspItem tag={'div'} key={index}>
              <Check />
              {item}
            </UspItem>
          ))}
        </Usp>
      ))}
    </UspWrap>
    <Trustbox />
    <Footer>
      <FooterPaymentIcons>
        <Amex></Amex>
        <Apay></Apay>
        <Mc></Mc>
        <Visa></Visa>
      </FooterPaymentIcons>
      <FooterNav>
        <FooterNavItem>
          <a href="https://typeandmore.dk/pages/sporgsmal-svar">
            Spørgsmål & Svar
          </a>
        </FooterNavItem>

        <FooterNavItem>
          <a href="https://typeandmore.dk/pages/need-help-were-here-for-you">
            Kontakt os
          </a>
        </FooterNavItem>

        <FooterNavItem>
          <a href="https://typeandmore.dk/pages/terms-and-conditions">
            Terms &amp; Conditions
          </a>
        </FooterNavItem>

        <FooterNavItem>
          <a href="https://typeandmore.dk/pages/privacy-policy">
            Privacy Policy
          </a>
        </FooterNavItem>
      </FooterNav>
    </Footer>
  </>
)
